import cn from 'classnames';
import {
  components,
  ClearIndicatorProps,
  DropdownIndicatorProps,
  Props,
} from 'react-select';

import { Icon } from '../Icon/Icon';

import styles from './Select.module.scss';
import { OptionType } from './Select.types';

const ClearIndicator = (props: ClearIndicatorProps<OptionType>) => (
  <components.ClearIndicator {...props}>
    <Icon name="close" size={24} />
  </components.ClearIndicator>
);

const DropdownIndicator = (props: DropdownIndicatorProps<OptionType>) => {
  const { selectProps } = props;
  const isOpen = selectProps.menuIsOpen;

  return (
    <components.DropdownIndicator {...props}>
      <div
        className={cn(styles.dropdownIcon, {
          [styles.isOpen]: isOpen,
        })}
      >
        <Icon name="arrowDown" size={24} />
      </div>
    </components.DropdownIndicator>
  );
};

export const selectComponents: Props<OptionType>['components'] = {
  IndicatorSeparator: null,
  ClearIndicator,
  DropdownIndicator,
};
